import snakeCase from 'lodash/snakeCase';
import type CSVHeaderColumn from '../../types/CSVHeaderColumn';
import type CSVRow from '../../types/CSVRow';

export function parseCsvHeaders(
  csvHeaderRow: CSVRow,
  rows: CSVRow[],
): CSVHeaderColumn[] {
  if (!csvHeaderRow) {
    throw new Error();
  }

  const parsed = csvHeaderRow.map((name: string, i: number) => ({
    hasData: false,
    id: `${snakeCase(name)}-${i}`,
    index: i,
    name,
  }));

  const arr: Array<string | never>[] = [];

  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i];

    for (let j = 0; j < row.length; j += 1) {
      arr[j] = arr[j] || [];
      arr[j][i] = rows[i][j];
    }
  }

  for (let i = 0; i < arr.length; i += 1) {
    const join = arr[i].join('');

    if (join.trim().length) {
      parsed[i].hasData = true;
    }
  }

  return parsed;
}

export default {
  parseCsvHeaders,
};
